var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('h1',[_vm._v(_vm._s(_vm.$t('pageTitle')))]),_c('ImportPortfolio')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }